export const validateForm = (form) => {
  return (form as Vue & {
    validate: () => boolean;
  }).validate();
};

export const resetFormValidation = (form) => {
  return (form as Vue & {
    resetValidation: () => boolean;
  }).resetValidation();
};
